// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"f6b0a463","313":"798a30ba","376":"3a722c60","533":"61a75b79","553":"75c55799","618":"dd43550c","978":"2bcf479d"}[chunkId] + ".chunk.js";
};